import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import StoreGroup from './StoreGroup'
import StorePage from './StorePage'

const StoreVoucher = ({ stores }) => {
  return (
    <Fragment>
      <Helmet>
        <title>{`Todos os cupons e serviços - ${process.env.REACT_APP_TITLE || ''}`}</title>
      </Helmet>
      <StorePage>
        <div className='row'>
          <StoreGroup
            items={stores.vouchers}
            title='Aqui você pode resgatar vouchers e cupons.'
            hasContent={stores.vouchers.length > 0}
          />

          <StoreGroup
            items={stores.services}
            title='Ou ainda serviços exclusivos.'
            hasContent={stores.services.length > 0}
          />

        </div>
      </StorePage>
    </Fragment>
  )
}

StoreVoucher.propTypes = {
  stores: PropTypes.object.isRequired
}

const mapStateToProps = ({ stores }) => ({
  stores
})

export default connect(
  mapStateToProps,
  null
)(StoreVoucher)



// WEBPACK FOOTER //
// ./src/features/Store/StoreVoucher.js